@import '../../style/focus-outline.scss';

:host {
    --wcs-grid-gap: 0;
    --wcs-grid-vertical-align: middle;
    --wcs-grid-outline-color: var(--wcs-semantic-color-border-focus-base);

    --wcs-grid-cell-text-color: var(--wcs-semantic-color-text-secondary);
    --wcs-grid-cell-padding-horizontal: var(--wcs-semantic-spacing-large);
    --wcs-grid-cell-padding-vertical: var(--wcs-semantic-spacing-base);
    --wcs-grid-cell-border-bottom: none;
    --wcs-grid-cell-separator-border: none;
    --wcs-grid-first-cell-border-radius: 0;
    --wcs-grid-last-cell-border-radius: 0;

    --wcs-grid-highlight-color: var(--wcs-semantic-color-background-surface-accent-lighter);
    --wcs-grid-row-background-color: var(--wcs-semantic-color-background-surface-primary);
    --wcs-grid-row-odd-background-color: var(--wcs-grid-row-background-color);
    --wcs-grid-row-even-background-color: var(--wcs-semantic-color-background-surface-accent-lightest);

    /* Grid headers for grid-columns */
    --wcs-grid-header-background-color-default: var(--wcs-semantic-color-background-action-secondary-default);
    --wcs-grid-header-background-color-hover: var(--wcs-semantic-color-background-action-secondary-hover);
    --wcs-grid-header-background-color-press: var(--wcs-semantic-color-background-action-secondary-press);
    --wcs-grid-header-text-color: var(--wcs-semantic-color-text-primary);
    --wcs-grid-header-font-weight: var(--wcs-semantic-font-weight-heavy);
    --wcs-grid-header-font-size: var(--wcs-semantic-font-size-label-1);
    --wcs-grid-header-line-height: var(--wcs-primitive-font-line-height-140);
    --wcs-grid-header-padding-vertical: var(--wcs-semantic-spacing-base);
    --wcs-grid-header-padding-horizontal: var(--wcs-semantic-spacing-large);
    --wcs-grid-header-border-left: none;
    --wcs-grid-header-border-radius: 0;
    --wcs-grid-header-border-bottom: solid var(--wcs-semantic-border-width-default) var(--wcs-semantic-color-border-secondary);
    --wcs-grid-header-transition-duration: var(--wcs-semantic-motion-duration-feedback-fast);
    --wcs-grid-first-header-background-color: var(--wcs-semantic-color-background-action-secondary-default);
    --wcs-grid-first-header-border-radius: 0;
    --wcs-grid-last-header-border-radius: 0;
    --wcs-grid-column-selection-width: calc(5 * var(--wcs-semantic-spacing-base));
    --wcs-grid-header-sort-arrow-color-default: var(--wcs-semantic-color-foreground-action-neutral-default);
    --wcs-grid-header-sort-arrow-color-hover: var(--wcs-semantic-color-foreground-action-neutral-hover);

    display: block;

    // These selectors cannot be moved in grid-column.scss, because the column itself doesn't know its child order
    // in the DOM, column are rendered one by one
    // 👇
    th {
        // For the header of the selection column (not part of grid-column)
        border-radius: var(--wcs-grid-first-header-border-radius);
        background-color: var(--wcs-grid-first-header-background-color);
    }

    ::slotted([slot=grid-column]:first-child) {
        // Remove the border for the first column
        --wcs-grid-header-border-left: none;
    }

    // If the grid displays a selection column, we set the border radius and color on the
    // first data column (which has been disabled in :host)
    :host([selection]) {
        ::slotted([slot=grid-column]:first-child) {
            --wcs-component-grid-header-border-radius-first: 0;
            --wcs-grid-header-border-left: var(--wcs-grid-header-border-left);
        }
    }

    // 👆

    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: var(--wcs-grid-gap);

        thead {
            border-bottom: var(--wcs-grid-header-border-bottom);
        }

        tbody {
            vertical-align: var(--wcs-grid-vertical-align);
        }
    }


    td {
        color: var(--wcs-grid-cell-text-color);
        margin: 0;
        padding:  var(--wcs-grid-cell-padding-vertical) var(--wcs-grid-cell-padding-horizontal);

        &:focus-visible {
            @include focus-outline($outline-color: var(--wcs-grid-outline-color), $outline-offset: 0);
        }

        &:first-child {
            border-radius: var(--wcs-grid-first-cell-border-radius);
        }

        &:last-child {
            border-radius: var(--wcs-grid-last-cell-border-radius);
        }

        &:not(:first-child) {
            border-left: var(--wcs-grid-cell-separator-border);
        }
    }

    tr {
        background-color: var(--wcs-grid-row-background-color);

        &:nth-child(odd) {
            background-color: var(--wcs-grid-row-odd-background-color, var(--wcs-grid-row-background-color));
        }

        &:nth-child(even) {
            background-color: var(--wcs-grid-row-even-background-color, var(--wcs-grid-row-background-color));
        }
    }

    tr:not(:last-child) td {
        border-bottom: var(--wcs-grid-cell-border-bottom);
    }

    .wcs-grid-selection-column {
        padding: var(--wcs-grid-cell-padding-vertical) var(--wcs-grid-cell-padding-horizontal);
        width: var(--wcs-grid-column-selection-width);
        text-align: start;
    }

    tr.selected {
        background-color: var(--wcs-grid-highlight-color);
    }

    .loading {
        text-align: center;
    }
}
